import { usePalette } from "../dashboards/kit";

export default function MiniPreview({ visual }) {
  const w = 320, h = 96;
  const c = usePalette();
  return (
    <div className="overflow-hidden rounded-t-2xl border-b border-line bg-cream p-4" data-testid="mini-preview">
      <svg viewBox={`0 0 ${w} ${h}`} className="h-24 w-full" role="img" aria-label="Case study preview (illustrative)">
        {[24, 48, 72].map((y) => <line key={y} x1="8" x2={w - 8} y1={y} y2={y} stroke="#E7E4EC" strokeDasharray="3 3" />)}
        {visual === "invoice-recon" && (
          <>
            {[[30, 58, 70, false], [100, 44, 84, true], [170, 66, 58, false], [240, 50, 72, false]].map(([x, a, b, flag], i) => (
              <g key={i}>
                <rect x={x} y={h - a} width="14" height={a} rx="2" fill={c.navy} />
                <rect x={x + 18} y={h - b} width="14" height={b} rx="2" fill={c.blue} />
                {flag && <rect x={x + 36} y={h - (b - a)} width="8" height={b - a} rx="2" fill={c.orange} />}
                {flag && <circle cx={x + 40} cy={h - (b - a) - 8} r="3.5" fill={c.red} />}
              </g>
            ))}
          </>
        )}
        {visual === "returns" && (
          <>
            <polyline points="16,20 55,30 94,26 133,44 172,52 211,62 250,70 289,74" fill="none" stroke={c.blue} strokeWidth="3" strokeLinecap="round" />
            <polyline points="172,52 211,62 250,70 289,74" fill="none" stroke={c.teal} strokeWidth="3" strokeLinecap="round" />
            <circle cx="16" cy="20" r="4.5" fill={c.red} />
            <circle cx="289" cy="74" r="4.5" fill={c.teal} />
          </>
        )}
        {visual === "supply-chain" && (
          <>
            {[[24, 40, c.navy], [66, 30, c.blue], [108, 46, c.navy], [150, 26, c.blue], [192, 36, c.orange], [234, 20, c.blue], [276, 30, c.teal]].map(([x, a, fill], i) => (
              <rect key={i} x={x} y={h - a} width="22" height={a} rx="3" fill={fill} />
            ))}
          </>
        )}
        {visual === "automation" && (
          <>
            {[[16, c.slate, "#fff", true], [120, c.blue, "#fff", false], [224, c.teal, "#fff", false]].map(([x, fill, text, dashed], i) => (
              <g key={i}>
                <rect x={x} y={h / 2 - 16} width="80" height="32" rx="16" fill={dashed ? "#fff" : fill} stroke={fill} strokeWidth="1.5" strokeDasharray={dashed ? "4 3" : "0"} />
                <text x={x + 40} y={h / 2 + 4} textAnchor="middle" fontSize="10" fontWeight="600" fill={dashed ? fill : text}>
                  {["Manual", "Automate", "Validate"][i]}
                </text>
                {i < 2 && <text x={x + 94} y={h / 2 + 4} fontSize="14" fill={c.slate}>→</text>}
              </g>
            ))}
          </>
        )}
        {visual === "process" && (
          <>
            <rect x="12" y="12" width="56" height="18" rx="9" fill="#fff" stroke={c.slate} />
            <rect x="80" y="12" width="56" height="18" rx="9" fill="#fff" stroke={c.slate} />
            <rect x="148" y="12" width="76" height="18" rx="9" fill={c.orange} />
            <rect x="12" y="40" width="76" height="18" rx="9" fill="#fff" stroke={c.navy} strokeWidth="1.5" />
            <rect x="100" y="40" width="56" height="18" rx="9" fill="#fff" stroke={c.red} strokeDasharray="4 3" />
            <rect x="12" y="68" width="56" height="18" rx="9" fill={c.teal} />
            <rect x="80" y="68" width="76" height="18" rx="9" fill="#fff" stroke={c.teal} />
          </>
        )}
      </svg>
    </div>
  );
}
